export default __webpack_public_path__ + "static/media/path5.037b2fce.png";